/**
 * Returns the platform-appropriate keyboard shortcut for "copy". Used in
 * fallback UI strings where we tell the user to copy manually.
 */
export function getOsCopyShortcut(): 'Cmd-C' | 'Ctrl-C' {
  if (typeof navigator === 'undefined') return 'Ctrl-C';
  const ua = navigator.userAgent;
  const platform = (navigator as { platform?: string }).platform ?? '';
  const isMac = /Mac|iPhone|iPad|iPod/i.test(platform) || /Macintosh|iPhone|iPad|iPod/i.test(ua);
  return isMac ? 'Cmd-C' : 'Ctrl-C';
}
